import * as React from 'react';
import * as styles from './styles.css';

export const Pseudolink: React.FC<React.ComponentProps<'button'>> = props => {
  return <button {...props} className={styles['pseudolink']} />;
};

Pseudolink.displayName = 'Pseudolink';
